import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from './auth/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private matSnackBar = inject(MatSnackBar);
  private auth = inject(AuthService);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err) {
          if (err.status === HttpStatusCode.PaymentRequired) {
            this.auth.updateUserStripeStatus();
            if (err?.error?.message) {
              this.matSnackBar.open(err.error.message, undefined, {
                duration: 5000,
              });
            }
          }
        }
        return throwError(() => err);
      })
    );
  }
}
